import { render, staticRenderFns } from "./ResetToDefaultProfile.vue?vue&type=template&id=b3f6da86&scoped=true&"
import script from "./ResetToDefaultProfile.vue?vue&type=script&lang=js&"
export * from "./ResetToDefaultProfile.vue?vue&type=script&lang=js&"
import style0 from "./ResetToDefaultProfile.vue?vue&type=style&index=0&id=b3f6da86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f6da86",
  null
  
)

export default component.exports